// source: template-project@7007a338a apps/backoffice/src/lib/utils.ts (cn)
import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import { DS_TYPOGRAPHY } from '@/design-system/tokens';

/**
 * tailwind-merge with the design system's type styles registered as font sizes.
 *
 * Out of the box tailwind-merge does not know `text-body-sm`, `text-label`, `text-tab`, `text-caption` …
 * (design-system/tailwind-plugin.cjs) and files them under `text-<color>`, so `cn('text-label', 'text-ds-text-3')`
 * dropped the type style and kept only the colour: the ported TP Badge and our rows silently rendered at the
 * inherited 16px. With the styles in the `font-size` group a style and a colour coexist, and a style still
 * replaces an earlier `text-sm` or another style.
 */
const twMerge = extendTailwindMerge({
  extend: { classGroups: { 'font-size': [{ text: Object.keys(DS_TYPOGRAPHY) }] } },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
